import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";
import SdStorageIcon from "@mui/icons-material/SdStorage";
import { useAuthentication } from "../customHook/useAuthentecation";
import { USER_RIGHTS } from "../constants/constants";

function MenuEntry({ handleNavigation }) {
  const [openEnt, setOpenEnt] = useState(false);
  const handleClick = () => {
    setOpenEnt(!openEnt);
  };
  //const navigate = useNavigate();
  const { auth } = useAuthentication();
  return (
    <List sx={{ bgcolor: "background.paper" }} component="nav">
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <SdStorageIcon style={{ color: "Green" }} />
        </ListItemIcon>
        <ListItemText primary="Entry" sx={{ color: "Green" }} />
        {openEnt ? (
          <ExpandLess style={{ color: "red" }} />
        ) : (
          <ExpandMore style={{ color: "green" }} />
        )}
      </ListItemButton>
      <Collapse in={openEnt} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ color: "Green" }}>
          {/* -------------------Indent------------------------------- */}

          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("indent")}
              // {() => handleNavigation("/entryPage")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="New Indent Entry" />
            </ListItemButton>
          )}

          {/* -------------------PO------------------------------- */}

          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("polist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="PO Entry" />
            </ListItemButton>
          )}

          {/* -------------------Item Received------------------------------- */}

          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("itemreceivedlist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="Received Materials Entry" />
            </ListItemButton>
          )}

          {/* -------------------Suitability------------------------------ */}

          {(auth?.userrights === USER_RIGHTS.SSEI ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("suitabilitylist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="Suitability Entry" />
            </ListItemButton>
          )}
          {/* -----------------------Bill Receipt-------------------------- */}
          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("billpendinglist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="Received Bill Entry" />
            </ListItemButton>
          )}
          {/* -----------------------COS/G-------------------------- */}

          {(auth?.userrights === USER_RIGHTS.COSG ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("cosglist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="Bill Passing/Funding Entry" />
            </ListItemButton>
          )}

          {/* ----------------------Sent to Account--------------------------- */}
          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("accountpendiglist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="CRN Entry" />
            </ListItemButton>
          )}

          {/* --------------------------Payment done by Account----------------------- */}

          {(auth?.userrights === USER_RIGHTS.CONSIGNEE ||
            auth?.userrights === USER_RIGHTS.ACCOUNTS ||
            auth?.userrights === USER_RIGHTS.ADMIN) && (
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("paymentlist")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "LawnGreen" }} />
              </ListItemIcon>
              <ListItemText primary="Payment Entry" />
            </ListItemButton>
          )}



{(auth?.userrights === USER_RIGHTS.CONSIGNEE) &&  (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("poExtension")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Extend DP Date" />
            </ListItemButton>
  
            
          )} 
          
           
        </List>
      </Collapse>
    </List>
  );
}

export default MenuEntry;
